export const Logos = {
	alandsbanken: 'alandsbanken',
	danskebank: 'danskebank',
	default: 'default',
	forex: 'forex',
	handelsbanken: 'handelsbanken',
	icabanken: 'icabanken',
	lansforsakringar: 'lansforsakringar',
	nordea: 'nordea',
	seb: 'seb',
	skandiabanken: 'skandiabanken',
	sparbankensyd: 'sparbankensyd',
	swedbank: 'swedbank',
	'swedbank&sparbankerna': 'swedbank',
	/*
	 * Trustly logos for Finland
	 */
	aktia: 'aktia',
	poppankki: 'poppankki',
	op: 'op',
	revolut: 'revolut',
	saastopankki: 'saastopankki',
	omasp: 'omasp',
	spankki: 'spankki',
	/*
	 * Adyen logos
	 */
	abnanl2a: 'abnamro',
	snsbnl2a: 'asnbanksns',
	asnbnl21: 'asnbank',
	bunqnl2a: 'bunq',
	ingbnl2a: 'ing',
	knabnl2h: 'knab',
	ntsbdeb1: 'n26',
	nnbanl2g: 'nationalenederlanden',
	rabonl2u: 'rabobank',
	rbrbnl21: 'regiobank',
	trionl2u: 'triodosbank',
	fvlbnl22: 'vanlanschotkempen',
	bitsnl2a: 'yoursafe',
	revolt21: 'revolut',
	buutnl2a: 'buut',
	testnl2a: sessionStorage.getItem('mockIdealBank')
} as const;

export enum LogoType {
	colored = 'default',
	mono = 'Mono',
	icon = 'Icon',
	icon_mono = 'IconMono'
}
